// extracted by css-extract-rspack-plugin
export default {"step":"HxqdY7jNUnEjr7G2","body":"o85vueEhnx8wSlFe","actions":"U19urWz6kKd_bV8d"};